import { useEffect, useState } from 'react'
import { formatVersion, getVersionInfo } from '../utils/version'

export function useVersion(): string {
  const [version, setVersion] = useState('')

  useEffect(() => {
    void getVersionInfo().then((info) => setVersion(formatVersion(info)))
  }, [])

  return version
}
